// config.js
export const API_BASE_URL = "https://newbackend-repo.onrender.com";
 //export const API_BASE_URL = "http://localhost:3000";
//export const API_BASE_URL = "https://api.financeshastra.com";

